import { CurrencyCodes } from 'common/configs/currency';

// #region CustomerSummary
export enum CustomerTypes {
  INDIVIDUAL = 'individual',
  COMPANY = 'company',
  NSP = 'nsp',
}

export interface CustomerSummary {
  agent: string;
  agent_id: number;
  balances: {
    deposits: string;
    cleared: string;
    reconciled: string;
    final_balance: string;
    outstanding: string;
    outstanding_age: string;
    pending: string;
    adjustments: string;
  };
  cleared: string;
  deposits: string;
  final_balance: string;
  outstanding: string;
  pending: string;
  reconciled: string;
  customer: string;
  customer_country: string;
  customer_id: number;
  customer_name: string;
  customer_username: string;
  customer_type: CustomerTypes;
  client_account_code: string;
  last_placement_date: string;
  wallet: string;
  wallet_credit: string | null;
  wallet_currency: string;
  wallet_description: string;
  wallet_id: number;
  wallet_min_balance: string | null;
  wallet_threshold: string | null;
}

interface CustomerSummariesStarted {
  type: 'customers/summaries/started';
}

interface CustomerSummariesFinished {
  type: 'customers/summaries/finished';
  summaries?: CustomerSummary[];
  error?: string;
}

export type CustomerSummariesActions =
  | CustomerSummariesStarted
  | CustomerSummariesFinished;

interface SettleCustomerStarted {
  type: 'customers/settle/started';
}

interface SettleCustomerFinished {
  type: 'customers/settle/finished';
  success?: boolean;
  error?: string;
}

export type SettleCustomerActions =
  | SettleCustomerStarted
  | SettleCustomerFinished;

interface ReconcileCustomerStarted {
  type: 'customers/reconcile/started';
}

interface ReconcileCustomerFinished {
  type: 'customers/reconcile/finished';
  success?: boolean;
  error?: string;
}

export type ReconcileCustomerActions =
  | ReconcileCustomerStarted
  | ReconcileCustomerFinished;

interface CurrencyConvertStarted {
  type: 'customers/currency_convert/started';
}

interface CurrencyConvertFinished {
  type: 'customers/currency_convert/finished';
  success?: boolean;
  error?: string;
}

export type CurrencyConvertActions =
  | CurrencyConvertStarted
  | CurrencyConvertFinished;
// #endregion

// #region Customer
export interface Customer {
  url: string;
  id: number;
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  type: string | null;
  code: string | null;
  groups: string[];
  default_currency: CurrencyCodes;
}

interface CustomerStarted {
  type: 'customer/started';
}

interface CustomerFinished {
  type: 'customer/finished';
  customer?: Customer;
  error?: string;
}

export type CustomerActions = CustomerStarted | CustomerFinished;
// #endregion

// #region CustomerOustanding
export interface CustomerOutstanding {
  customer_id: number;
  system: string;
  account_id: number;
  stream: string;
  currency: CurrencyCodes;
  account_codes: string[];
  amount: string;
  customer_username: string;
  account_username: string;
  system_name: string;
  stream_name: string;
  customer_url: string;
  account_url: string;
}

interface CustomerOutstandingsStarted {
  type: 'customers/outstandings/started';
}

interface CustomerOutstandingsFinished {
  type: 'customers/outstandings/finished';
  outstandings?: CustomerOutstanding[];
  error?: string;
}

export type CustomerOutstandingsActions =
  | CustomerOutstandingsStarted
  | CustomerOutstandingsFinished;
// #endregion

// #region WhitelabelAccount
export interface WhitelabelAccount {
  account_code: string;
  balance: string;
  currency: string;
  name: string;
}

interface WhitelabelAccountsStarted {
  type: 'whitelabels/accounts/started';
}

interface WhitelabelAccountsFinished {
  type: 'whitelabels/accounts/finished';
  accounts?: WhitelabelAccount[];
  error?: string;
}

export type WhitelabelAccountsActions =
  | WhitelabelAccountsStarted
  | WhitelabelAccountsFinished;
// #endregion

// #region TermsAndConditions
export interface TermsAndConditions {
  terms_accepted: boolean;
}

interface TermsAndConditionsStarted {
  type: 'terms/started';
}

interface TermsAndConditionsFinished {
  type: 'terms/finished';
  tncs?: TermsAndConditions;
  error?: string;
}

export type TermsAndConditionsActions =
  | TermsAndConditionsStarted
  | TermsAndConditionsFinished;

interface AcceptTermsAndConditionsStarted {
  type: 'terms/accept/started';
}

interface AcceptTermsAndConditionsFinished {
  type: 'terms/accept/finished';
  tncs?: TermsAndConditions;
  error?: string;
}

export type AcceptTermsAndConditionsActions =
  | AcceptTermsAndConditionsStarted
  | AcceptTermsAndConditionsFinished;
// #endregion
